export const COMMAND_HANDLER_REGISTERED_EVENT = 'MF_COMMAND_HANDLER_REGISTERED';

export type CommandHandlerRegisteredEvent = {
	name: string;
};
